/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AssinaturaCriteriaDto } from '../models/assinatura-criteria-dto';
import { AssinaturaDto } from '../models/assinatura-dto';
import { AssinaturaFormDto } from '../models/assinatura-form-dto';
import { AssinaturaPageDto } from '../models/assinatura-page-dto';


/**
 * Assinaturas dos responsáveis
 */
@Injectable({
  providedIn: 'root',
})
export class AssinaturasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAssinaturas
   */
  static readonly GetAssinaturasPath = '/assinaturas';

  /**
   * Pesquisar assinaturas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAssinaturas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssinaturas$Response(params?: {
    criteria?: AssinaturaCriteriaDto;
  }): Observable<StrictHttpResponse<AssinaturaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, AssinaturasService.GetAssinaturasPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssinaturaPageDto>;
      })
    );
  }

  /**
   * Pesquisar assinaturas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAssinaturas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssinaturas(params?: {
    criteria?: AssinaturaCriteriaDto;
  }): Observable<AssinaturaPageDto> {

    return this.getAssinaturas$Response(params).pipe(
      map((r: StrictHttpResponse<AssinaturaPageDto>) => r.body as AssinaturaPageDto)
    );
  }

  /**
   * Path part for operation submeterAssinatura
   */
  static readonly SubmeterAssinaturaPath = '/assinaturas';

  /**
   * Submeter Assinatura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterAssinatura()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterAssinatura$Response(params?: {
    body?: {
'assinaturaForm'?: AssinaturaFormDto;
'documentoAssinatura'?: Blob;
}
  }): Observable<StrictHttpResponse<AssinaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, AssinaturasService.SubmeterAssinaturaPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssinaturaDto>;
      })
    );
  }

  /**
   * Submeter Assinatura.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterAssinatura$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterAssinatura(params?: {
    body?: {
'assinaturaForm'?: AssinaturaFormDto;
'documentoAssinatura'?: Blob;
}
  }): Observable<AssinaturaDto> {

    return this.submeterAssinatura$Response(params).pipe(
      map((r: StrictHttpResponse<AssinaturaDto>) => r.body as AssinaturaDto)
    );
  }

  /**
   * Path part for operation getAssinatura
   */
  static readonly GetAssinaturaPath = '/assinaturas/{id}';

  /**
   * Obter assinatura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAssinatura()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssinatura$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<AssinaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, AssinaturasService.GetAssinaturaPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssinaturaDto>;
      })
    );
  }

  /**
   * Obter assinatura.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAssinatura$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssinatura(params: {
    id: number;
  }): Observable<AssinaturaDto> {

    return this.getAssinatura$Response(params).pipe(
      map((r: StrictHttpResponse<AssinaturaDto>) => r.body as AssinaturaDto)
    );
  }

  /**
   * Path part for operation updateAssinatura
   */
  static readonly UpdateAssinaturaPath = '/assinaturas/{id}';

  /**
   * Editar Assinatura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAssinatura()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateAssinatura$Response(params: {
    id: number;
    body?: {
'assinaturaForm'?: AssinaturaFormDto;
'documentoAssinatura'?: Blob;
}
  }): Observable<StrictHttpResponse<AssinaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, AssinaturasService.UpdateAssinaturaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssinaturaDto>;
      })
    );
  }

  /**
   * Editar Assinatura.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAssinatura$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateAssinatura(params: {
    id: number;
    body?: {
'assinaturaForm'?: AssinaturaFormDto;
'documentoAssinatura'?: Blob;
}
  }): Observable<AssinaturaDto> {

    return this.updateAssinatura$Response(params).pipe(
      map((r: StrictHttpResponse<AssinaturaDto>) => r.body as AssinaturaDto)
    );
  }

  /**
   * Path part for operation ativarAssinatura
   */
  static readonly AtivarAssinaturaPath = '/assinaturas/{id}/ativar';

  /**
   * Ativar Assinaturas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarAssinatura()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarAssinatura$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<AssinaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, AssinaturasService.AtivarAssinaturaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssinaturaDto>;
      })
    );
  }

  /**
   * Ativar Assinaturas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarAssinatura$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarAssinatura(params: {
    id: number;
  }): Observable<AssinaturaDto> {

    return this.ativarAssinatura$Response(params).pipe(
      map((r: StrictHttpResponse<AssinaturaDto>) => r.body as AssinaturaDto)
    );
  }

  /**
   * Path part for operation desativarAssinatura
   */
  static readonly DesativarAssinaturaPath = '/assinaturas/{id}/desativar';

  /**
   * Desativar assinaturas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarAssinatura()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarAssinatura$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<AssinaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, AssinaturasService.DesativarAssinaturaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssinaturaDto>;
      })
    );
  }

  /**
   * Desativar assinaturas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarAssinatura$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarAssinatura(params: {
    id: number;
  }): Observable<AssinaturaDto> {

    return this.desativarAssinatura$Response(params).pipe(
      map((r: StrictHttpResponse<AssinaturaDto>) => r.body as AssinaturaDto)
    );
  }

}
